import { eFeatureFlags } from 'ui-toolkit/authentication/types/eFeatureFlags';
import { useGetConfigQuery } from '../API/applicationConfig/ApplicationConfigAPI';
import { IConfigurationParameters } from '../ui-toolkit/authentication/types/AuthenticationConfig';
import { useMemo } from 'react';

const defaultConfigurationParameters: Partial<IConfigurationParameters> = {
  featureFlags: {},
};

export const useHasFeatureFlag = (featureFlagName: eFeatureFlags): boolean => {
  const { data: { featureFlags } = defaultConfigurationParameters } = useGetConfigQuery();
  return featureFlags?.[featureFlagName] ?? false;
};

export const useHasFeatureFlags = (featureFlagNames: eFeatureFlags[]): boolean[] => {
  const { data: { featureFlags } = defaultConfigurationParameters } = useGetConfigQuery();
  return useMemo(() => {
    return featureFlagNames.map((name) => featureFlags?.[name] ?? false);
  }, [featureFlags, featureFlagNames]);
};
